import "slick-carousel";

import "slick-carousel/slick/slick.css";

$(document).ready(() => {
  // product image sliders
  $(".images__large").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    rows: 0,
    fade: true,
    asNavFor: $(".images__small")
  });

  $(".images__large").on("afterChange", function(event, slick, currentSlide) {
    const imageId = $(slick.$slides.get(currentSlide)).data("image-id");

    const furniturePrintLinkLogo1 = $("#furniture-print-link-logo-1");
    const furniturePrintLink1 = $("#furniture-print-link-1");
    const furniturePrintLinkLogo2 = $("#furniture-print-link-logo-2");
    const furniturePrintLink2 = $("#furniture-print-link-2");

    if (furniturePrintLinkLogo1.length) {
      let urlFixer = $(furniturePrintLinkLogo1).attr("href");
      if (!urlFixer.startsWith("http"))
        urlFixer = window.location.origin + urlFixer;
      let url = new URL(urlFixer);
      url.searchParams.set("image_id", imageId);
      $(furniturePrintLinkLogo1).attr("href", url.href);
    }

    if (furniturePrintLink1.length) {
      let urlFixer = $(furniturePrintLink1).attr("href");
      if (!urlFixer.startsWith("http"))
        urlFixer = window.location.origin + urlFixer;
      let url = new URL(urlFixer);
      url.searchParams.set("image_id", imageId);
      $(furniturePrintLink1).attr("href", url.href);
    }

    if (furniturePrintLinkLogo2.length) {
      let urlFixer = $(furniturePrintLinkLogo2).attr("href");
      if (!urlFixer.startsWith("http"))
        urlFixer = window.location.origin + urlFixer;
      let url = new URL(urlFixer);
      url.searchParams.set("image_id", imageId);
      $(furniturePrintLinkLogo2).attr("href", url.href);
    }

    if (furniturePrintLink2.length) {
      let urlFixer = $(furniturePrintLink2).attr("href");
      if (!urlFixer.startsWith("http"))
        urlFixer = window.location.origin + urlFixer;
      let url = new URL(urlFixer);
      url.searchParams.set("image_id", imageId);
      $(furniturePrintLink2).attr("href", url.href);
    }
  });

  const imagesSmallSlickOpts = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: $(".images__large"),
    dots: true,
    appendDots: $(".images-sm-dots"),
    centerMode: true,
    arrows: false,
    rows: 0,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };
  $(".images__small").slick(imagesSmallSlickOpts);

  // hide sm images if only one
  $(".slick-track li:only-child")
    .closest(".images__small")
    .hide();
  $(".slick-dots li:only-child")
    .closest(".images-sm-dots")
    .hide();

  // related carousel
  $("#related").slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    rows: 0,
    prevArrow: $("#relatedPrev"),
    nextArrow: $("#relatedNext"),
    appendDots: $("#relatedDots"),
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575.98,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
